var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "textToSpeech"
  }, [_c("section", {
    style: {
      background: `url(${_vm.imageUrl}) no-repeat center 0px`,
      backgroundSize: "cover"
    }
  }, [_c("Banner", {
    attrs: {
      imageUrl: _vm.imageUrl,
      title: "语音合成",
      description: _vm.bannerText
    }
  })], 1), _c("section", {
    staticClass: "products"
  }, [_c("div", {
    staticClass: "products-main"
  }, [_c("Title", {
    attrs: {
      title: "产品体验"
    }
  }), _c("section", {
    staticClass: "products-content"
  }, [_c("div", {
    staticClass: "content-left"
  }, [_c("a-textarea", {
    attrs: {
      rows: 18,
      maxLength: 300,
      showCount: ""
    },
    model: {
      value: _vm.demoText,
      callback: function ($$v) {
        _vm.demoText = $$v;
      },
      expression: "demoText"
    }
  }), _vm._m(0)], 1), _c("div", {
    staticClass: "content-right"
  }, [_c("div", {
    staticClass: "mb10"
  }, [_c("a-radio-group", {
    attrs: {
      "button-style": "solid"
    },
    model: {
      value: _vm.composeType,
      callback: function ($$v) {
        _vm.composeType = $$v;
      },
      expression: "composeType"
    }
  }, _vm._l(_vm.modelList, function (model, index) {
    return _c("a-radio-button", {
      key: index,
      attrs: {
        value: model.name
      }
    }, [_vm._v(_vm._s(model.name) + " ")]);
  }), 1)], 1), _c("div", {
    staticClass: "model-list"
  }, _vm._l(_vm.curModels, function (model) {
    return _c("div", {
      key: model.model_code,
      staticClass: "model-item",
      class: [model.model_code === _vm.selectedModel && "active-model"],
      on: {
        click: function ($event) {
          return _vm.selectModel(model);
        }
      }
    }, [model.sex === 1 ? _c("img", {
      staticClass: "male-img",
      attrs: {
        src: _vm.female,
        alt: ""
      }
    }) : _c("img", {
      staticClass: "male-img",
      attrs: {
        src: _vm.male,
        alt: ""
      }
    }), _vm._v(" " + _vm._s(model.model_simple_name) + " ")]);
  }), 0), _c("div", {
    staticClass: "slider-area"
  }, [_c("div", {
    staticClass: "demo-slider"
  }, [_c("div", {
    staticClass: "item-label mr20"
  }, [_vm._v("语速")]), _c("a-slider", {
    staticClass: "slider mr20",
    attrs: {
      min: 50,
      max: 200
    },
    model: {
      value: _vm.speed,
      callback: function ($$v) {
        _vm.speed = $$v;
      },
      expression: "speed"
    }
  }), _c("div", {
    staticClass: "slider-value mr20"
  }, [_vm._v(_vm._s(_vm.speed))])], 1), _c("div", {
    staticClass: "demo-slider"
  }, [_c("div", {
    staticClass: "item-label mr20"
  }, [_vm._v("语调")]), _c("a-slider", {
    staticClass: "slider mr20",
    attrs: {
      min: -500,
      max: 500
    },
    model: {
      value: _vm.intonation,
      callback: function ($$v) {
        _vm.intonation = $$v;
      },
      expression: "intonation"
    }
  }), _c("div", {
    staticClass: "slider-value mr20"
  }, [_vm._v(_vm._s(_vm.intonation))])], 1), _c("div", {
    staticClass: "demo-slider"
  }, [_c("div", {
    staticClass: "item-label mr20"
  }, [_vm._v("音量")]), _c("a-slider", {
    staticClass: "slider mr20",
    attrs: {
      min: 0,
      max: 100
    },
    model: {
      value: _vm.volumn,
      callback: function ($$v) {
        _vm.volumn = $$v;
      },
      expression: "volumn"
    }
  }), _c("div", {
    staticClass: "slider-value mr20"
  }, [_vm._v(_vm._s(_vm.volumn))])], 1)])])]), _c("audio", {
    staticStyle: {
      display: "none"
    },
    attrs: {
      src: _vm.audioSource,
      controls: ""
    }
  }), _c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm.status === "uncomposed" ? _c("a-button", {
    staticClass: "compose-btn",
    attrs: {
      type: "primary",
      disabled: _vm.demoText.length === 0
    },
    on: {
      click: _vm.compose
    }
  }, [_vm._v("立即合成")]) : _vm._e(), _vm.status === "composing" ? _c("a-button", {
    staticClass: "compose-btn",
    attrs: {
      type: "primary",
      loading: true
    }
  }, [_vm._v("合成中 ")]) : _vm._e(), _vm.status === "playing" ? _c("a-button", {
    staticClass: "compose-btn",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.stopPlay
    }
  }, [_vm._v("暂停 ")]) : _vm._e(), _vm.status === "pause" ? _c("a-button", {
    staticClass: "compose-btn",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.continuePlay
    }
  }, [_vm._v("恢复播放 ")]) : _vm._e()], 1)], 1)]), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "advantages-main"
  }, [_c("Title", {
    attrs: {
      title: "产品优势"
    }
  }), _c("div", {
    staticClass: "content"
  }, [_c("Advantages2", {
    attrs: {
      leftItems: _vm.adsListLeft,
      rightItems: _vm.adsListRight
    }
  })], 1)], 1)]), _c("section", {
    staticClass: "applications"
  }, [_c("div", {
    staticClass: "applications-main"
  }, [_c("Title", {
    attrs: {
      title: "应用场景"
    }
  }), _c("section", {
    staticClass: "applications-content"
  }, _vm._l(_vm.applicationsList, function (item, index) {
    return _c("BusiCard", {
      key: index,
      attrs: {
        title: item.title,
        desc: item.desc,
        img: item.img,
        dark: true
      }
    });
  }), 1)], 1)]), _c("SpeechCase", {
    attrs: {
      title: "合作案例",
      casesList: _vm.casesList
    }
  }), _c("Appointment2")], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "text-tip"
  }, [_vm._v("试用版最多可输入"), _c("span", [_vm._v(" 300 ")]), _vm._v("个字符，超出部分将被省略")]);
}];
render._withStripped = true;
export { render, staticRenderFns };